import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CURRENCY_FORMAT } from "../../../utils/helper";
import { CircularProgress } from "@mui/material";
import { TranslateText } from "../../../utils/translation";

const Payments = () => {
  const { paymentDetails, invoiceDetails, loadingDetails } = useSelector(
    (store) => store.booking
  );

  const [roomInvoice, setRoomInvoice] = useState({});
  const [posTotal, setPosTotal] = useState(0);
  const [totalPayments, setTotalPayments] = useState(0);
  const [refund, setRefund] = useState(0);
  const [roomTax, setRoomTax] = useState(0);
  const [balanceDue, setBalanceDue] = useState(0);
  const [addOnsTotal, setAddonsTotal] = useState(0);

  useEffect(() => {
    if (Array.isArray(invoiceDetails)) {
      let localRoomInvoice = invoiceDetails?.filter(
        (Obj) => Obj?.invoiceType === "roomBill"
      )?.[0];

      const cgst = Boolean(localRoomInvoice?.cgst) ? +localRoomInvoice.cgst : 0;
      const sgst = Boolean(localRoomInvoice?.sgst) ? +localRoomInvoice.sgst : 0;
      const tax = Boolean(localRoomInvoice?.totalTax)
        ? +localRoomInvoice.totalTax
        : 0;

      let localAddOnRateObject = localRoomInvoice?.priceBreakup?.find(
        (Obj) => Obj?.type === "Addons"
      );

      let localAddOnRate = Boolean(localAddOnRateObject)
        ? localAddOnRateObject?.addOns?.reduce(
            (acc, currObj) => acc + (currObj?.price * currObj?.count ?? 0),
            0
          )
        : 0;

      let localRoomTax = Boolean(tax) ? tax : cgst + sgst;

      const localPayemnts = paymentDetails
        ?.map((item) => item.amount)
        ?.filter((Obj) => Boolean(Obj))
        ?.filter((Obj) => Obj > 0)
        ?.reduce((total, num) => total + num, 0);

      const localRefund = paymentDetails
        ?.map((item) => item.amount)
        ?.filter((Obj) => Boolean(Obj))
        ?.filter((Obj) => Obj < 0)
        ?.reduce((total, num) => total + -num, 0);

      let localPosTotal = invoiceDetails
        ?.filter((item) => item.invoiceType !== "roomBill")
        ?.map((item) => item.total)
        ?.filter((Obj) => Boolean(Obj))
        ?.reduce((total, num) => total + num, 0);

      let allTotal = invoiceDetails
        ?.map((item) => item.total)
        ?.filter((Obj) => Boolean(Obj))
        ?.reduce((total, num) => total + num, 0);

      let remainigBalance = allTotal - localPayemnts + localRefund;

      setAddonsTotal(localAddOnRate);
      setRoomInvoice(localRoomInvoice);
      setRoomTax(localRoomTax);
      setTotalPayments(localPayemnts);
      setRefund(localRefund);
      setPosTotal(localPosTotal);
      setBalanceDue(remainigBalance);
    }
  }, [invoiceDetails, paymentDetails]);

  return (
    <div className="w-[100%] rounded-xl mt-1 py-2 px-4 flex justify-between  text-[10px] mx-3">
      {loadingDetails ? (
        <div className="flex w-[100%] items-center justify-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          <div
            className="flex flex-col items-start cursor-pointer"
            // onClick={() => dispatch(updateDisplayDetailedBreakupModal(true))}
          >
            <div className="flex gap-1 items-center">
              <div className="text-[#667085] font-[400]  text-[12px]">
                Room Amount
              </div>
            </div>

            <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
              {Boolean(roomInvoice)
                ? Boolean(roomInvoice?.subTotal && roomInvoice?.discount)
                  ? CURRENCY_FORMAT(
                      roomInvoice?.subTotal + roomInvoice?.discount
                    )
                  : CURRENCY_FORMAT(roomInvoice?.subTotal)
                : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          <div className="flex flex-col items-start">
            <div className="text-[#667085] font-[400]  text-[12px]">
              Discount
            </div>

            <div className="text-[#039855]  font-medium  text-[14px] leading-[21px]">
              {Boolean(roomInvoice?.discount)
                ? CURRENCY_FORMAT(roomInvoice?.discount)
                : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          <div className="flex flex-col items-start">
            <div className="text-[#667085] font-[400]  text-[12px]">
              <TranslateText textKey={"sub_total"} namespace="booking" />
            </div>
            <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
              {Boolean(invoiceDetails)
                ? Boolean(roomInvoice?.subTotal)
                  ? CURRENCY_FORMAT(roomInvoice?.subTotal)
                  : "00"
                : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          {Boolean(addOnsTotal) ? (
            <>
              <div className="flex flex-col items-start">
                <div className="text-[#667085] font-[400]  text-[12px]">
                  <TranslateText textKey={"AddOns"} namespace="booking" />
                </div>
                <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
                  {Boolean(addOnsTotal) ? CURRENCY_FORMAT(addOnsTotal) : "00"}
                </div>
              </div>
              <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />
            </>
          ) : (
            <></>
          )}

          <div className="flex flex-col items-start">
            <div className="text-[#667085] font-[400]  text-[12px]">Tax</div>
            <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
              {Boolean(roomTax) ? CURRENCY_FORMAT(roomTax) : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          <div className="flex flex-col items-start">
            <div className="text-[#667085] font-[400]  text-[12px]">
              <TranslateText textKey={"room_total"} namespace="booking" />
            </div>
            <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
              {Boolean(roomInvoice?.total)
                ? CURRENCY_FORMAT(roomInvoice?.total)
                : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          <div className="flex flex-col items-start">
            <div className="text-[#667085] font-[400]  text-[12px]">
              <TranslateText textKey={"pos_total"} namespace="booking" />
            </div>
            <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
              {Boolean(posTotal) ? CURRENCY_FORMAT(posTotal) : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          <div className="flex flex-col items-start text-[#808080]">
            <div className="text-[#667085] font-[400]  text-[12px]">
              <TranslateText textKey={"total_deposit"} namespace="booking" />
            </div>
            <div className="font-medium text-[14px] leading-[21px] text-[#007FFF]">
              {Boolean(totalPayments) ? CURRENCY_FORMAT(totalPayments) : "00"}
            </div>
          </div>

          <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />

          {Boolean(refund) ? (
            <>
              <div className="flex flex-col items-start text-[#808080]">
                <div className="text-[#667085] font-[400]  text-[12px]">
                  <TranslateText textKey={"refund"} namespace="booking" />
                </div>
                <div className="font-medium  text-[14px] leading-[21px] text-[#222B45]">
                  {Boolean(refund) ? CURRENCY_FORMAT(refund) : "00"}
                </div>
              </div>
              <div className="border-[0.5px] border-[#F0F0F0] w-[1px] h-[40px] " />
            </>
          ) : (
            <></>
          )}

          <div className="flex flex-col items-start ">
            <div className="text-[#667085] font-[400]  text-[12px]">
              <TranslateText textKey={"balance_due"} namespace="booking" />
            </div>
            <div className="font-[600] text-[#D92D20] text-[14px] leading-[21px]">
              {Boolean(balanceDue) ? CURRENCY_FORMAT(balanceDue) : "00"}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Payments;
